import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CustomerDetailChip from "../../Customers/CustomerDetail/CustomerDetailChip";
import { sectionCardSx, sectionTitleSx } from "./agentDetailSectionStyles";

export default function AgentDetailKbSection({ kbPermissions = [] }) {
  if (!kbPermissions.length) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={sectionTitleSx}>Knowledge Base Permissions</Typography>
      <Box sx={sectionCardSx}>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
          {kbPermissions.map((label) => (
            <CustomerDetailChip key={label} label={label} />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
